import { render, staticRenderFns } from "./SortClockAscendingOutline.vue?vue&type=template&id=1036c150"
import script from "./SortClockAscendingOutline.vue?vue&type=script&lang=js"
export * from "./SortClockAscendingOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports